<template>
  <div>
    <h5>
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-divider />
    <form class="pa-5">
      <v-text-field
        v-model="item.name"
        :label="$t('form.name')"
        required
        outlined
        readonly
      ></v-text-field>
      <v-row>
        <v-col cols="12">
          <v-text-field
            :value="$t(item.reason)"
            :label="$t('form.reason')"
            required
            outlined
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="item.description"
            :label="$t('form.description')"
            required
            outlined
            readonly
          ></v-textarea>
        </v-col>
      </v-row>

      <SupervisorActions
        v-if="!this.$route.meta.see_user"
        :item="item"
        :object_type="object_type"
        :form_name="form_name"
        :state="state"
        :supervisor="supervisor !== null ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
      <div v-else class="text-center">
        <v-btn text class="mr-4 mb-4" @click="$router.go(-1)">{{
          $t("button.back")
        }}</v-btn>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import SupervisorActions from "../action_buttons/SupervisorActions";
import RejectCommentLayout from "../layouts/RejectCommentLayout";
export default {
  components: { SupervisorActions, RejectCommentLayout },
  data: () => ({
    state: "",
    supervisor: "",
    form_name: "",
    object_type: "",
    reject_comment: "",
    title: "",
    item: {
      name: "",
      description: "",
      reason: ""
    }
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path;
      if (this.isAuthorize) {
        path =
          this.$store.state.endpoint +
          "/direction/moderatedOperations/authorize/" +
          this.$route.params.object_type +
          "/" +
          this.$route.params.id;
      } else {
        path =
          this.$store.state.endpoint +
          "/moderatedOperations/review/" +
          this.$route.params.object_type +
          "/" +
          this.$route.params.id;
      }
      axios
        .get(path)
        .then(response => {
          this.state = response.data.state;
          this.object_type = response.data.object_type;
          this.form_name = response.data.form_name;
          this.title = response.data.title;
          this.supervisor = response.data.supervisor;
          this.reject_comment = response.data.reject_comment;
          this.item = response.data.data.user;
        })
        .catch(error => {
          console.log(error);
        });
    },

    accept() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/" +
        this.$route.params.object_type +
        "/validate/" +
        this.$route.params.id;
      axios
        .patch(path)
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: "Delete request successfully validated."
          });
          this.$router.push("/manage/forms");
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: "An error occurred while validating the delete request"
          });
        });
    },

    reject() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/" +
        this.$route.params.object_type +
        "/reject/" +
        this.$route.params.id;
      axios
        .patch(path)
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: "Delete request successfully rejected."
          });
          this.$router.push("/manage/forms");
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: "An error occurred while rejecting the delete request"
          });
        });
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    },

    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>
